import { render, staticRenderFns } from "./GlobalError.vue?vue&type=template&id=5f85a76a&scoped=true&"
import script from "./GlobalError.vue?vue&type=script&lang=js&"
export * from "./GlobalError.vue?vue&type=script&lang=js&"
import style0 from "./GlobalError.vue?vue&type=style&index=0&id=5f85a76a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f85a76a",
  null
  
)

export default component.exports